import { useState } from "react";
import { fluxuri } from "./fluxuri.js";
import { tr } from "./i18n.js";

/**
 * „Cum se lucrează" — diagramele celor șase fluxuri.
 *
 * Desenate în HTML și CSS, nu cu o bibliotecă de diagrame: șase lanțuri de
 * pași nu justifică nici câteva sute de kilobytes plătiți la fiecare
 * încărcare, nici o dependență nouă. Aceeași decizie ca la graficele din
 * rapoarte.
 *
 * Fiecare pas e un buton: duce chiar în secțiunea în care se lucrează pasul
 * acela. O diagramă din care nu poți intra în aplicație e un afiș.
 */
export default function Fluxuri({ mergiLa, sectiuniPermise }) {
  const lista = fluxuri();
  const [deschis, setDeschis] = useState(lista[0]?.cod ?? null);

  // Un pas dintr-o secțiune pe care rolul n-o vede rămâne DESENAT — face parte
  // din proces, iar procesul nu se schimbă cu rolul — dar nu mai e apăsabil.
  // Ascunderea lui ar rupe lanțul și ar arăta ca un proces cu găuri.
  const potIntra = (cod) => !sectiuniPermise || sectiuniPermise.includes(cod);

  return (
    <div className="continut">
      <h1>{tr("Cum se lucrează")}</h1>
      <p className="subtitlu">
        {tr("Șase fluxuri, atât. Fiecare pas duce în secțiunea în care se lucrează, iar sub fiecare scrie ce trece mai departe — legătura dintre două module nu e o săgeată desenată, e o coloană sau o tranzacție.")}
      </p>

      {/*
        Toate șase cu descrierea lor, nu doar cu numele: „Ofertare" sau
        „Analiză și conformitate" nu spun singure ce cuprind, iar un om nou n-are
        de unde ghici care flux îl privește dacă trebuie să le deschidă pe rând
        ca să afle.
      */}
      <div className="fluxuri-lista">
        {lista.map((f, i) => (
          <button
            key={f.cod}
            className={"flux-card" + (f.cod === deschis ? " activ" : "")}
            onClick={() => setDeschis(f.cod)}
          >
            <span className="flux-card-titlu">
              <span className="tab-numar">{i + 1}</span> {f.titlu}
            </span>
            <span className="flux-card-rezumat">{f.rezumat}</span>
            <span className="flux-card-pasi">
              {f.pasi.map((p) => p.titlu).join(" → ")}
            </span>
          </button>
        ))}
      </div>

      {lista.filter((f) => f.cod === deschis).map((f) => (
        <div key={f.cod}>
          <div className="panou">
            <div className="panou-antet"><span>{f.titlu}</span></div>
            <div className="panou-corp">
              <ol className="flux">
                {f.pasi.map((p, i) => (
                  <li key={i} className="flux-pas">
                    <div className="flux-cap">
                      <span className="flux-numar">{i + 1}</span>
                      {potIntra(p.sectiune) ? (
                        <button className="buton buton-mic buton-sters"
                          onClick={() => mergiLa(p.sectiune)}>
                          {p.titlu}
                        </button>
                      ) : (
                        <span className="flux-titlu-inactiv" title={tr("Funcția ta nu lucrează la pasul ăsta.")}>
                          {p.titlu}
                        </span>
                      )}
                    </div>
                    <p className="flux-face">{p.face}</p>
                    <p className="flux-duce"><strong>{tr("Mai departe:")}</strong> {p.duce}</p>
                  </li>
                ))}
              </ol>

              {f.ramuri.length > 0 && (
                <>
                  <h4>{tr("Ce se poate ramifica")}</h4>
                  <ul className="lista-rezultate">
                    {f.ramuri.map((r, i) => (
                      <li key={i}>
                        {potIntra(r.sectiune) ? (
                          <button className="buton buton-mic buton-discret"
                            onClick={() => mergiLa(r.sectiune)}>
                            {tr("deschide")}
                          </button>
                        ) : null}
                        <span className="rezultat-context">{r.text}</span>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
